/**
 * Generates a URL-safe slug from a club name.
 * Example: "SuperKonnected Podcast Netwerk!" -> "superkonnected-podcast-netwerk"
 */
export function generateClubSlug(name: string): string {
  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')   // strip diacritics (e -> e, u -> u, etc.)
    .replace(/[^a-z0-9\s-]/g, '')      // remove special chars
    .trim()
    .replace(/\s+/g, '-')              // spaces -> hyphens
    .replace(/-+/g, '-')               // collapse multiple hyphens
    .slice(0, 80);                     // max 80 chars
}

/**
 * Canonical URL for a club story page.
 */
export function clubCanonicalUrl(slugOrId: string): string {
  return `https://superkonnected.com/clubs/${slugOrId}`;
}

/**
 * Canonical URL for a user profile page.
 */
export function profileCanonicalUrl(slugOrId: string): string {
  return `https://superkonnected.com/profiel/${slugOrId}`;
}

/**
 * Truncate text to a maximum length, ending at a word boundary.
 */
export function truncateForMeta(text: string, maxLength = 155): string {
  if (text.length <= maxLength) return text;
  const cut = text.lastIndexOf(' ', maxLength);
  return (cut > 0 ? text.slice(0, cut) : text.slice(0, maxLength)) + '...';
}

